import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	commandPaletteFooterTitle: {
		id: 'shortcuts-dialog.modal.command-palette-footer-title',
		defaultMessage: `Link issues with {isMac, select,
            true {Cmd + K}
            other {Ctrl + K}
        }`,
		description:
			'Title for message to onboard users to the Command Palette instead of the dot menu',
	},
	commandPaletteFooterDescription: {
		id: 'shortcuts-dialog.modal.command-palette-footer-description',
		defaultMessage: 'A keyboard-first way to create relationships between issues in Jira.',
		description: 'Message to onboard users to the Command Palette instead of the dot menu',
	},
	sunsetDotMenuWarningTitle: {
		id: 'shortcuts-dialog.modal.sunset-dot-menu-warning-title',
		defaultMessage: 'We’re removing the dot menu',
		description: 'Title for sun set dot menu warning',
	},
	sunsetDotMenuWarningDescription: {
		id: 'shortcuts-dialog.modal.sunset-dot-menu-warning-description',
		defaultMessage:
			'From August 19, we’ll remove this menu to make way for an improved command palette. Press <strong>{isMac, select, true {Cmd + K} other {Ctrl + K}}</strong> on your keyboard to try it now.',
		description: 'Description for sun set dot menu warning',
	},
	tryNowButton: {
		id: 'shortcuts-dialog.modal.sunset-dot-menu-warning-try-now-button',
		defaultMessage: 'Try now',
		description: 'Button text for try now action',
	},
	learnMoreButton: {
		id: 'shortcuts-dialog.modal.sunset-dot-menu-warning-learn-more-button',
		defaultMessage: 'Why remove the dot menu?',
		description: 'Button text for learn more action that takes the user to a community post',
	},
	dotMenuRemovalTitle: {
		id: 'shortcuts-dialog.modal.dot-menu-removal-title',
		defaultMessage: 'Try the improved command palette',
		description: 'Title for message to onboard users to the Command Palette',
	},
	dotMenuRemovalDescription: {
		id: 'shortcuts-dialog.modal.dot-menu-removal-description',
		defaultMessage:
			'We removed the dot menu to make way for the command palette.{isEmbed, select, true {} other { Press <strong>{isMac, select, true {Cmd + K} other {Ctrl + K}}</strong> on your keyboard to try it now.}}',
		description: 'Description for message to onboard users to the Command Palette',
	},
});
